(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

$(window).on("load",function(event){
    $(".loadingPageSection").css("display","none");
    $("body").css("overflow","unset");
});

$( document ).ready(function() 
{
    if(jQuery.browser.mobile)
    {
        // $(".phoneBtn").click(function(){
        //     $(this).attr("href","tel:+52 (999) 944 09 76 ");
        // });
        $(".contactBtnSection").click(function(){
            $(this).attr("href","tel: 991 915 2366");
        });
        $(".contactBtnFooter").click(function(){
            $(this).attr("href","tel: 991 915 2366");
        });       
         
    }
    else
    {
        // $(".phoneBtn").click(function(){
        //     $('html, body').animate({
        //         scrollTop: 0
        //     }, 500);
        // });        
    }

    $(".showMenuIcon").click(function()
    {
        if($(this).hasClass("active"))
        {
            $(".navSection:first").removeClass("active");
            $(this).removeClass("active");
        }
        else
        {
            $(".navSection:first").addClass("active");
            $(this).addClass("active");
        }
    });

    window.onscroll = function() {headerSticky()};
    var header = document.getElementById("header");    
    var sticky = header.offsetTop;

    function headerSticky() 
    {
        if(header)
        {
            if (window.pageYOffset > sticky) 
            {
                header.classList.add("sticky");              
            } 
            else 
            {
                header.classList.remove("sticky");
            }
        }        
    }

    $(".linkOnPage").click(function ()
    {
        if($(".navSection:first").hasClass("active"))
        {
            $(".navSection:first").removeClass("active");
            $(".showMenuIcon:first").removeClass("active");
        }      
        $('html, body').animate({
            scrollTop: $($(this).attr("moveTo")).offset().top - 95
        }, 2000);
    });

    $(window).on('scroll', function(event) {
        if($(this).scrollTop() > 600){
            $('.backToTopBtn').css("display","flex");
            $('.backToTopBtn').fadeIn(200);
        } else{
            $('.backToTopBtn').fadeOut(200);
        }
    });
    
    //Animate the scroll to top
    $('.backToTopBtn').on('click', function(event) {
        event.preventDefault();
        
        $('html, body').animate({
            scrollTop: 0,
        }, 1500);
    });


    //form send
    $(".formBtn").on("click",function()
    {    

        $(".validationErrors").hide();
        $(".errorFormMail").hide();

        

        var fakeFormInputNameValue = $("#formInputName").val();
        var fakeFormInputMailValue = $("#formInputMail").val();
        var fakeFormInputPhoneValue = $("#formInputPhone").val();
        var fakeFormInputMessageValue = $("#formInputMessage").val();

        var errorOnValidate = false;
        var errorOnEmail = false;
        var errorOnForm = false;

        if(fakeFormInputNameValue && fakeFormInputMailValue && fakeFormInputPhoneValue && fakeFormInputMessageValue)
        {
            if(fakeFormInputNameValue !="" && fakeFormInputMailValue !="" && fakeFormInputPhoneValue !="" && fakeFormInputMessageValue !="" )
            {
                if(isEmail(fakeFormInputMailValue))
                {
                    errorOnValidate = false;  
                }
                else
                {
                    errorOnValidate = true;  
                    errorOnEmail = true;
                }
                              
            }
            else
            {
                errorOnValidate = true;
            }
        }
        else
        {
            errorOnValidate = true;
        }

        if(!errorOnValidate)
        {
            var ifrm = document.getElementById("hs-form-iframe-0");
            var doc = ifrm.contentDocument? ifrm.contentDocument: ifrm.contentWindow.document;
            var inputDiv_name = doc.getElementsByClassName("hs_nombre").item(0);
            console.log("1");
            console.log(inputDiv_name);
            var inputTag_name = inputDiv_name.getElementsByClassName("hs-input").item(0);

            var inputDiv_mail = doc.getElementsByClassName("hs_email").item(0);
            var inputTag_mail = inputDiv_mail.getElementsByClassName("hs-input").item(0);            

            var inputDiv_phone = doc.getElementsByClassName("hs_phone").item(0);
            var inputTag_phone = inputDiv_phone.getElementsByClassName("hs-input").item(0);

            var inputDiv_message = doc.getElementsByClassName("hs_message").item(0);
            var inputTag_message = inputDiv_message.getElementsByClassName("hs-input").item(0);

            var inputDiv_button = doc.getElementsByClassName("hs_submit").item(0);
            var inputTag_button = inputDiv_button.getElementsByClassName("hs-button").item(0);

            var hs_form = doc.getElementsByClassName("hs-form").item(0);

            inputTag_name.value = fakeFormInputNameValue;
            console.log(fakeFormInputNameValue);
            console.log(inputTag_name.value );
            inputTag_mail.value = fakeFormInputMailValue;
            inputTag_phone.value = fakeFormInputPhoneValue;
            inputTag_message.value = fakeFormInputMessageValue;

            hs_form.submit();

            console.log("submitted");
            
            $(".formContainer").hide();
            $(".success").show();
            // $(".errorFormText").show();

        }
        else
        {
            if(errorOnEmail)
            {
                $(".errorFormMail").show();
            }
            else
            {
                $(".validationErrors").css("display","flex");
            }
            
            // $(".errorFormMail").hide();
            // $(".formSectionContent").show();
            // $(".succesFormText").show();
            // $(".errorFormText").show();
        }

        



        // console.log(inputTag_name);
        // inputTag_name.value = "name test";
        // console.log(inputTag_name.value);

        // inputDiv.value = "some name";
    //    var ifrm = $("#hs-form-iframe-0");
    //    console.log(ifm);
    });

    function isEmail(email) 
    {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

});//end doc ready

